// src/components/home/ToastNotifications.js
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import LoanToastContent from "../../common/toaster/loantoastcontent";
import { fetchToast } from "../../store/slices/toastSlice";

const ToastNotifications = () => {
  const dispatch = useDispatch();
  const { data: toastDataFromApi } = useSelector((state) => state.toast);
  const timeoutsRef = useRef([]);

  useEffect(() => {
    dispatch(fetchToast()); // ✅ dispatch the correct action
  }, [dispatch]);

  useEffect(() => {
    if (!toastDataFromApi?.success || !Array.isArray(toastDataFromApi.data)) {
      return;
    }

    const toastMessages = toastDataFromApi.data.filter(
      (toast) => toast.active_status === true,
    );

    if (toastMessages.length === 0) return;

    timeoutsRef.current.forEach(clearTimeout);
    timeoutsRef.current = [];

    toastMessages.forEach((toastData, index) => {
      const timeoutId = setTimeout(() => {
        const ToastComponent = (
          <LoanToastContent
            title={toastData.title}
            fullName={toastData.full_name}
            message={toastData.message}
            image={toastData.image_url}
            toastType={toastData.toast_type}
            highlight={toastData.highlight}
          />
        );

        const toastMethod = toast[toastData.toast_type] || toast.info;
        toastMethod(ToastComponent, {
          position: "bottom-left",
          autoClose: 4500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          closeButton: false,
        });
      }, index * 5500);

      timeoutsRef.current.push(timeoutId);
    });

    return () => {
      timeoutsRef.current.forEach(clearTimeout);
      timeoutsRef.current = [];
    };
  }, [toastDataFromApi]);

  return null;
};

export default ToastNotifications;
